import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const ImagePreviewModal = ({ 
  isOpen, 
  onClose, 
  previewUrl, 
  imgRef,
  crop,
  setCrop,
  handleCropComplete,
  uploadError,
  handleRetryUpload,
  isUploading,
  uploadProgress,
  handleUpload,
  checkImageDimensions,
  setUploadError 
}) => {
  if (!isOpen) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1e1e1e] rounded-lg p-6 max-w-2xl w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-white">Previsualización de imagen</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {uploadError ? (
          <div className="bg-red-900 bg-opacity-20 border border-red-500 rounded-md p-4 mb-4">
            <p className="text-red-500">{uploadError}</p>
            <button
              onClick={handleRetryUpload}
              className="mt-2 px-3 py-1 bg-red-500 text-white rounded-md hover:bg-red-600"
            >
              Intentar nuevamente
            </button>
          </div>
        ) : null}
        
        <div className="mb-4">
          {previewUrl && (
            <div className="max-h-[400px] overflow-auto flex justify-center">
              <ReactCrop
                src={previewUrl}
                onImageLoaded={(img) => {
                  imgRef.current = img;
                  checkImageDimensions(img).catch(error => {
                    setUploadError(error);
                  });
                  return false;
                }}
                crop={crop}
                onChange={newCrop => setCrop(newCrop)}
                onComplete={handleCropComplete}
                circularCrop
                className="max-w-full"
              />
            </div>
          )}
        </div>
        
        {isUploading ? (
          <div className="mb-4">
            <div className="relative pt-1">
              <div className="flex mb-2 items-center justify-between">
                <div>
                  <span className="text-xs font-semibold inline-block text-[#ff1b6d]">
                    {uploadProgress}%
                  </span>
                </div>
              </div>
              <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-[#252525]">
                <div 
                  style={{ width: `${uploadProgress}%` }} 
                  className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-[#ff1b6d] transition-all duration-300"
                ></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-transparent border border-gray-600 text-gray-300 rounded-md hover:bg-[#252525] focus:outline-none"
            >
              Cancelar
            </button>
            <button
              onClick={handleUpload}
              disabled={!!uploadError}
              className={`px-4 py-2 bg-[#ff1b6d] text-white rounded-md focus:outline-none focus:ring-2 focus:ring-[#ff1b6d]/50 ${
                uploadError ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#ff1b6d]/90'
              }`}
            >
              Aplicar y subir
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImagePreviewModal;
